import { SYSTEM_EVENT_DEFINITION_TYPE } from "components/event-definitions/constants";
export const isSystemEventDefinition = (eventDefinition) => {
  var _a;
  return ((_a = eventDefinition == null ? void 0 : eventDefinition.config) == null ? void 0 : _a.type) === SYSTEM_EVENT_DEFINITION_TYPE;
};
export const isIlluminateEventDefinition = (eventDefinition) => (eventDefinition == null ? void 0 : eventDefinition._scope) === "ILLUMINATE";
export const isAggregationEventDefinition = (eventDefinition) => {
  var _a;
  return ((_a = eventDefinition == null ? void 0 : eventDefinition.config) == null ? void 0 : _a.type) === "aggregation-v1";
};
export const isSigmaEventDefinition = (eventDefinition) => {
  var _a;
  return ((_a = eventDefinition == null ? void 0 : eventDefinition.config) == null ? void 0 : _a.type) === "sigma-v1";
};
